import { useEffect } from 'react';

/**
 * Hook that detects clicks outside of the referenced element(s) and calls the handler.
 *
 * @param {React.RefObject|React.RefObject[]} refs - Single ref or array of refs to consider "inside"
 * @param {Function} handler - Called when a click occurs outside all refs
 * @param {boolean} [enabled=true] - Only listen when enabled
 */
function useClickOutside(refs, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const refArray = Array.isArray(refs) ? refs : [refs];

    const handleClickOutside = (event) => {
      const isInside = refArray.some(
        ref => ref.current && ref.current.contains(event.target)
      );
      if (!isInside) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [refs, handler, enabled]);
}

export default useClickOutside;
